import { createFeatureSelector, createSelector } from '@ngrx/store';
import { jobAdapter } from '../job/job.reducer';
import { DashboardFeatureJobState, FEATURE_KEY } from './feature.reducer';

export const selectFeature =
  createFeatureSelector<DashboardFeatureJobState>(FEATURE_KEY);

// Job Entity State
export const selectJobsState = createSelector(
  selectFeature,
  (state) => state.jobs
);
export const jobSelectors = jobAdapter.getSelectors(selectJobsState);

// View Selectors
export const selectModalViewModel = createSelector(
  jobSelectors.selectAll,
  (jobs) => ({
    jobs,
  })
);

export const selectMenuItemViewModel = createSelector(
  jobSelectors.selectTotal,
  (total) => ({
    total,
  })
);

export interface SelectPanelViewModelFilter {
  workflowTypes?: string[];
  workflowIdSearch?: string[];
  runId?: string;
}

export const selectPanelViewModel = (filter: SelectPanelViewModelFilter) =>
  createSelector(jobSelectors.selectAll, (jobs) => {
    return {
      job: jobs.find((job) => {
        return (
          (!filter.workflowTypes?.length ||
            filter.workflowTypes?.includes(job.workflowType)) &&
          (!filter.runId || job.runId === filter.runId) &&
          (!filter.workflowIdSearch?.length ||
            filter.workflowIdSearch.some((w) => job.workflowId.includes(w)))
        );
      }),
    };
  });
